<div class="login-container">
  <!-- Left Side - Login Form -->
  <div class="login-form-side">
    <a (click)="goBack()" class="go-back-link">
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
      </svg>
      Go Back
    </a>
    <div class="login-form-wrapper">
      <!-- Logo -->
      <!-- <h1 class="page-title">Login</h1> -->
      <div class="login-logo">
        <div class="logo-icon">RTT</div>
        <div class="logo-text">
          <div class="logo-company">RealTimeTrac</div>
          <div class="logo-tagline">Delivery Management System</div>
        </div>
      </div>

      <!-- Login Header -->
      <div class="login-header">
        <div
          style="font-size: 14px; font-weight: 600; color: var(--primary-green); text-transform: uppercase; letter-spacing: 1px; margin-bottom: 32px;">
          Your customers' time valued
        </div>
      </div>

      <!-- Login Form -->
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form" id="loginForm" novalidate>
         <div class="form-group">
          <label class="form-label">Enter Password <span class="required-indicator">*</span></label>
          <div style="position: relative;">
            <input 
              [type]="showNewPassword ? 'text' : 'password'"
              class="form-input"
              formControlName="enterpassword"
              placeholder="Enter your password"
              [class.error]="submitted && loginForm.get('enterpassword')?.invalid"
              (keydown)="onKeyDown($event)"
            />
            <button type="button" class="toggle-password" (click)="toggleNewPassword()">
              <!-- Eye Icon (Visible) -->
              <svg *ngIf="!showNewPassword" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
              <!-- Eye Slash Icon (Hidden) -->
              <svg *ngIf="showNewPassword" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
              </svg>
            </button>
          </div>
          <div class="error-message" *ngIf="submitted && loginForm.get('enterpassword')?.invalid">
            <svg style="position: relative;top:4px" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
            </svg>
            <span>
              <span *ngIf="loginForm.get('enterpassword')?.errors?.['required']">Password is required</span>
              <span *ngIf="loginForm.get('enterpassword')?.errors?.['minlength']">Password must be at least 6 characters</span>
            </span>
          </div>
        </div>

        <div class="form-group">
          <label class="form-label">Confirm Password <span class="required-indicator">*</span></label>
          <div style="position: relative;">
            <input 
              [type]="showConfirmPassword ? 'text' : 'password'"
              class="form-input"
              formControlName="confirmpassword"
              placeholder="Re-enter password"
              [class.error]="submitted && loginForm.get('confirmpassword')?.invalid"
              (keydown)="onKeyDown($event)"
            />
            <button type="button" class="toggle-password" (click)="toggleConfirmPassword()">
              <!-- Eye Icon (Visible) -->
              <svg *ngIf="!showConfirmPassword" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
              <!-- Eye Slash Icon (Hidden) -->
              <svg *ngIf="showConfirmPassword" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
              </svg>
            </button>
          </div>
          <div class="error-message" *ngIf="submitted && loginForm.get('confirmpassword')?.invalid">
            <svg style="position: relative;top:4px" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
            </svg>
            <span>
              <span *ngIf="loginForm.get('confirmpassword')?.errors?.['required']">Confirm Password is required</span>
              <span *ngIf="loginForm.get('confirmpassword')?.errors?.['minlength']">Password must be at least 6 characters</span>
            </span>
          </div>
        </div>

        <div class="error-message errorspass"
     *ngIf="
       submitted &&
      passwordMismatch
     ">
      <svg fill="currentColor" viewBox="0 0 20 20">
      <path fill-rule="evenodd"
        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
        clip-rule="evenodd" />
    </svg>

  Password and Confirm Password do not match
</div>
        <button type="submit" class="login-button" (click)="onSubmit()" [disabled]="loading">
          <ng-container *ngIf="!loading; else loadingSpinner">
            Update
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg>
          </ng-container>

          <ng-template #loadingSpinner>
            <span class="loading-spinner"></span>
          </ng-template>
        </button>

        <!-- Terms -->
        <p class="terms-text">
          By signing in, you agree to our <a href="#">Terms of Service</a> and <a href="#">Privacy Policy</a>.
        </p>
      </form>
    </div>
  </div>

  <!-- Right Side - Illustration -->
  <!-- Right Side - Illustration -->
  <div class="illustration-side">
    <div class="slider-container" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeaveWrapper()">

      <!-- Tagline -->
      <h2 class="slider-tagline">
        Schedule. <span class="highlight-green">TRAC</span>. Deliver on <span class="highlight-yellow">Time</span>
      </h2>

      <!-- Slider Wrapper -->
      <div class="slider-wrapper" #sliderWrapper (touchstart)="onTouchStart($event)" (touchend)="onTouchEnd($event)"
        (mousedown)="onMouseDown($event)" (mousemove)="onMouseMove($event)" (mouseup)="onMouseUp($event)"
        (mouseleave)="onMouseLeave()">

        <!-- Previous Arrow -->
        <button class="slider-arrow prev" (click)="prevSlide()" aria-label="Previous slide">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
        </button>

        <!-- Next Arrow -->
        <button class="slider-arrow next" (click)="nextSlide()" aria-label="Next slide">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </button>

        <!-- Slides -->
        <div class="slide" *ngFor="let slide of slides; let i = index" [ngClass]="{ 'active': currentSlide === i }">
          <div class="slide-image">
            <img [src]="slide.image" [alt]="slide.title">
          </div>
          <div class="slide-content">
            <h3 class="slide-title">{{ slide.title }}</h3>
            <p class="slide-description">{{ slide.description }}</p>
          </div>
        </div>
      </div>

      <!-- Progress Bar -->
      <div class="slider-progress">
         <div class="slider-progress-bar" [style.width.%]="((currentSlide + 1) / slides.length) * 100"></div>
      </div>

      <!-- Navigation Dots -->
      <div class="slider-nav">
        <div class="slider-dot" *ngFor="let slide of slides; let i = index" [ngClass]="{ 'active': currentSlide === i }"
          (click)="showSlide(i)">
        </div>
      </div>

    </div>
  </div>

</div>